export default __webpack_public_path__ + "static/media/wood-saw.d358b686.jpg";